import { render, staticRenderFns } from "./edit-contract-overlay.vue?vue&type=template&id=afa0a596&scoped=true"
import script from "./edit-contract-overlay.vue?vue&type=script&lang=js"
export * from "./edit-contract-overlay.vue?vue&type=script&lang=js"
import style0 from "./edit-contract-overlay.vue?vue&type=style&index=0&id=afa0a596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa0a596",
  null
  
)

export default component.exports